import { type WormholeList } from '../service';

type ElementStyle = Partial<CSSStyleDeclaration>;

export const createDragIcon = () => {
  const dragIcon = new Image();

  dragIcon.src =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAPZJREFUaEPtV7sVwjAMlHp7EhiCIWAewmSEIZjE7k1DjV50sv1klDqnz51+ZnL+sfP4KRKYrWAoEAqADEQJgQTC8PUVSCltzHwlohNM1zEDe2ttr7U+fsFEBXLOTyK6HPNt9ve7lHL+7wQml9Cr1rpBCpgVQydDYg908mtmNhIwo1JpSFTAfRPHHlCWxheGL7LJJYSfEhiB/dFiE/cPAfMQCWD84WhRgZTSnZlv8R7QkY2PUfeLbPIeiPeArnIHosQpNDAWlav1E5jcxPgx536Muk/A/SmhGg0DQetPoYFkqlyFAiraDEGhgCGZKlOhgIo2Q5B7BT5tQXAxcoYrQAAAAABJRU5ErkJggg==';
  dragIcon.draggable = false;

  const styles: ElementStyle = {
    position: 'absolute',
    top: '2px',
    left: '1px',
    height: '21px',
    cursor: 'move',
    zIndex: '99999',
  };
  Object.assign(dragIcon.style, styles);
  return dragIcon;
};

export const createInnerElement = () => {
  const innerWrapper = document.createElement('div');
  const styles: ElementStyle = { width: '170px', height: '25px' };
  Object.assign(innerWrapper.style, styles);
  return innerWrapper;
};

export const createOuterElement = (style: ElementStyle) => {
  const outerWrapper = document.createElement('div');
  const styles: ElementStyle = {
    position: 'absolute',
    top: '0px',
    right: '0px',
    zIndex: '99999',
    ...style,
  };
  Object.assign(outerWrapper.style, styles);
  return outerWrapper;
};

export const createSelectElement = (defaultValue: string, options: WormholeList[]) => {
  const selectElement = document.createElement('xy-select');
  if (!selectElement.shadowRoot) {
    throw new Error('shadowRoot in xy-select not found');
  }

  const borderElement: HTMLElement | null = selectElement.shadowRoot.querySelector(
    'xy-popover xy-tips>xy-button',
  );

  if (!borderElement) {
    throw new Error('borderElement not found');
  }

  const selectStyle = {
    width: '100%',
    height: '100%',
  };

  const borderStyle = {
    paddingLeft: '20px',
    backgroundColor: '#fff',
  };

  options.forEach(op => {
    const option = document.createElement('xy-option');
    option.setAttribute('value', op.site_url);
    option.innerText = op.data_center;
    selectElement.appendChild(option);
  });

  const isOriginInOptions = options.find(op => op.site_url.indexOf(defaultValue) > -1);
  if (isOriginInOptions) {
    selectElement.setAttribute('defaultvalue', isOriginInOptions.site_url);
  }
  Object.assign(selectElement.style, selectStyle);
  Object.assign(borderElement.style, borderStyle);

  return selectElement;
};
